import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Recaptcha from 'react-google-recaptcha';

const RecaptchaInput = ({ form }) => {
  const handleVerify = React.useCallback(
    (token) => {
      form.setFieldValue('g-recaptcha-response', token || '', true);
    },
    [form],
  );

  React.useLayoutEffect(() => {
    if (document.getElementById('recaptcha')) {
      return;
    }

    let tag = document.createElement('script');
    tag.id = 'recaptcha';
    tag.async = true;
    tag.defer = true;
    tag.src = 'https://www.google.com/recaptcha/api.js';
    document.body.appendChild(tag);
  });

  return (
    <Recaptcha
      theme="dark"
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      onChange={handleVerify}
    />
  );
};

const RecaptchaInputWrapper = () => {
  return <Field name="g-recaptcha-response" component={RecaptchaInput} />;
};

export default RecaptchaInputWrapper;

RecaptchaInput.propTypes = {
  form: PropTypes.object,
};
